// extracted by mini-css-extract-plugin
export default {"gradient":"gradient__UMXYI"};